export enum SpecialDDLValuesEnum  {
  ALL = 0,
  UNSPECIFIED = -1
}
